import { get, post } from "../utils/api/apiCaller";
import apiClient from "../utils/api/apiClient";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export const getAIA = (page = 1, limit = 20): Promise<ApiResponse> =>
  get(ENDPOINTS.SOV_SETUP.GET_AIA(page, limit));

export const createSOV = (
  projectId: string,
  data: unknown,
): Promise<ApiResponse> => post(ENDPOINTS.SOV_SETUP.CREATE(projectId), data);

export const draftSOV = (
  projectId: string,
  data: unknown,
): Promise<ApiResponse> => post(ENDPOINTS.SOV_SETUP.DRAFT(projectId), data);

export const getSubcontractors = (
  search: string,
  page = 1,
  limit = 20,
): Promise<ApiResponse> =>
  get(ENDPOINTS.SOV_SETUP.GET_SUBCONTRACTORS(search, page, limit));

export const getSOVDraft = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.SOV_SETUP.GET_SOV_DRAFT(projectId));

export const getSovVersions = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.SOV_SETUP.GET_SOV_VERSIONS(projectId));

export const getSovVersion = (
  projectId: string,
  versionId: string,
): Promise<ApiResponse> =>
  get(ENDPOINTS.SOV_SETUP.GET_SOV_VERSION(projectId, versionId));

export const importSOVFromExcel = (
  projectId: string,
  fileKey: string,
): Promise<ApiResponse> =>
  get(ENDPOINTS.SOV_SETUP.IMPORT_EXCEL(projectId, fileKey));

export const exportSOVCsv = async (
  projectId: string,
  versionId: string,
): Promise<void> => {
  const { data: blob, error } = await apiClient.call(
    "GET",
    ENDPOINTS.SOV_SETUP.EXPORT_CSV(projectId, versionId),
    { responseType: "blob" },
  );

  if (error) throw new Error("Failed to export CSV");

  const link   = document.createElement("a");
  link.href     = URL.createObjectURL(blob as Blob);
  link.download = "sov-lien-items.csv";
  link.click();
  URL.revokeObjectURL(link.href);
};
